import OrgUtil from "../util/organize";

export const withCategory = (supportGraph)=>{
	const combineKeys = {...supportGraph};
	OrgUtil.getAllCategoryName().forEach(k=>{
		combineKeys[k] = k;
	});
	return combineKeys;
};

export const BaseSupportGraph = {
	Gender:"gender",
	AgeRange:"age_range",
	Returning:"returning"
};
export const StressTestSupportGraph = {
	...BaseSupportGraph,
	Frequency:"frequency",
	StressLevel:"stress_level",
};
export const CounselingSupportGraph = {
	...BaseSupportGraph,
	Tag:"topic",
	Returning:"returning",
	Platform:"platform",
	ProviderType:"provider",
	VisitOutcome : "visit_outcome",
	// Division : "division",
	ProviderFeedback:"provider_feedback",
	PatientFeedback:"patient_feedback",
	/**
     * Special key which combine 'patient_feedback' and 'provider_feedback' into one
     */
	Feedback:"feedback"
};


// WEBPACK FOOTER //
// ./src/constants/supportGraph.js